import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DropdownMenuItem } from "@webapp/shared/gh-dropdown/gh-dropdown.models";

/**
 * @example <gh-dropdown [menuItems]="this.contextMenuItems"><span gh-dropdown-toggle class="gh-font-icon-menu"></span></gh-dropdown>
 * @param menuItems IDropdownMenuItem[]
 */
@Component({
  selector: "gh-dropdown",
  templateUrl: "./gh-dropdown.component.html",
  styleUrls: ["./gh-dropdown.component.less"],
})
export class GhDropdownComponent {
  @Output()
  dropdownToggled = new EventEmitter<boolean>();
  @Input()
  menuItems: DropdownMenuItem[];
  @Input()
  dropUp = false;
  @Input()
  dropdownMenuClass: string;

  onDropdownToggled(value: boolean) {
    this.dropdownToggled.emit(value);
  }
}
